/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/core';
import { layers } from '@atlaskit/theme/constants';
const primitiveCss = css`
  z-index: ${layers.tooltip()};
  pointer-events: none;
`;
const TooltipPrimitive = /*#__PURE__*/forwardRef(function TooltipPrimitive({
  style,
  className,
  children,
  placement,
  testId
}, ref) {
  return jsx("div", {
    role: "tooltip",
    ref: ref,
    style: style,
    className: className,
    css: primitiveCss,
    "data-placement": placement,
    "data-testid": testId
  }, children);
});
TooltipPrimitive.displayName = 'TooltipPrimitive';
export default TooltipPrimitive;